import { render, staticRenderFns } from "./FamilyRelation.vue?vue&type=template&id=55638fd2&scoped=true"
import script from "./FamilyRelation.vue?vue&type=script&lang=js"
export * from "./FamilyRelation.vue?vue&type=script&lang=js"
import style0 from "./FamilyRelation.vue?vue&type=style&index=0&id=55638fd2&prod&lang=css"
import style1 from "./FamilyRelation.vue?vue&type=style&index=1&id=55638fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55638fd2",
  null
  
)

export default component.exports